import { ReportConfig,ServiceQuickBiReportDataParams } from "@/component/common/report/report"
import { httpMobile, httpMobilePost } from "@/utils/httpMobile"
import { getMobileSkey } from "@/utils/utils"
import { CardData, configMock, reportList, tempalte } from "./mock"
import { AxiosResponse } from'axios'
import { TemplateDataModel } from "@/component/Template/TemplateDataModel"
import { convertSortParams } from "@/component/ReportCommon/share/params"




const getWrapHttpTestMock= <T>(data:T)=>{
  let res = {
    status:200,
    statusText:'ok',
    config:{headers:{},url:''},
    data:data
  } as  AxiosResponse<T>
  return  res
}


export const serviceQuickBiReportConfigMobile = async (params:{report:string})=>{


  // return getWrapHttpTestMock(configMock)


  return httpMobilePost<ReportConfig>({
    ...params,
    a:'quickBiReportConfig',  
    c:"Report",
  })
}


export type QuickBiReportDataResponse = {
  "hasNextPage": number // 0,
  "page": number // 1,
  "pageTotal": number // 0,
  "lastPageId": number // 0,
  "limit": number // 100,
  "count": number // 0,
  "countData": [],
  "listsDataSum": [],
  "listsData": Array<Record<string,string|number>>
}




export const serviceQuickBiReportDataMobile = async (_params:ServiceQuickBiReportDataParams)=>{
  let params = convertSortParams(_params)
  return httpMobilePost<QuickBiReportDataResponse>({
    ...params,
    val:{},
    a:'quickBiReportData',  
    c:"Report",
    limit:20,
  })
  // let data =  getWrapHttpTestMock(reportList)
  // return await new Promise<typeof data>((res)=>{
  //   setTimeout(()=>{
  //     res(data)
  //   },1000)
  // })
  // return data
}
interface QuickBiReportTemplateParams{
  template_code: string,
  source?: 'indicator',
  report:  string // ReportType
}

export const serviceQuickBiReportTemplateMobile = async (params:QuickBiReportTemplateParams)=>{
  return httpMobilePost<TemplateDataModel>({
    ...params,
    val:{},
    a:'quickBiReportTemplate',  
    c:"Report",
  })
  // return  getWrapHttpTestMock(tempalte)
}
// //测试完成需要移除，走serviceQuickBiReportDataMobile
// /** @deprecated */
// export const serviceQuickBiReportDataMobileCard = async ()=>{

//   return { data: CardData }
// }